export let SearchDisabledInGroup = "WP0M8";
export let GroupsSearchPlaceholder = "PfUiob";
export let SearchDisabled = "CCpsqd";
export let SearchDisabledSigninRequired = "rUL84";
export let archiveMailboxFoldersSearchPlaceholder = "cbKKs";
export let MOSAppSearchPlaceholder = "$zJiWd";
export let MOSAppSearchPlaceholderFallback = "RBq2Dc";
export default {SearchDisabledInGroup,GroupsSearchPlaceholder,SearchDisabled,SearchDisabledSigninRequired,archiveMailboxFoldersSearchPlaceholder,MOSAppSearchPlaceholder,MOSAppSearchPlaceholderFallback};